
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/health-tools/[...slug]",
      function () {
        return require("private-next-pages/health-tools/[...slug].tsx");
      }
    ]);
  